import { useMemo } from 'react';
import { mapGridFilters, mapGridSorts, type GridQueryInput } from './gridUtils';
import type { GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid';

type UseGridQueryInputParams = {
  paginationModel: GridPaginationModel;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
  fixedFilters?: GridQueryInput['filters'];
  search?: string;
};

type UseGridQueryInputResult = {
  queryInput: GridQueryInput;
  queryInputKey: string;
  fixedFiltersKey: string;
};

export const useGridQueryInput = ({
  paginationModel,
  sortModel,
  filterModel,
  fixedFilters,
  search,
}: UseGridQueryInputParams): UseGridQueryInputResult => {
  const fixedFiltersKey = useMemo(() => JSON.stringify(fixedFilters ?? []), [fixedFilters]);
  const queryInput = useMemo<GridQueryInput>(
    () => ({
      page: (paginationModel.page as number) + 1,
      pageSize: paginationModel.pageSize,
      sorts: mapGridSorts(sortModel),
      filters: [...mapGridFilters(filterModel), ...(fixedFilters ?? [])],
      search,
    }),
    [filterModel, fixedFilters, paginationModel.page, paginationModel.pageSize, search, sortModel],
  );
  const queryInputKey = useMemo(() => JSON.stringify(queryInput), [queryInput]);

  return { queryInput, queryInputKey, fixedFiltersKey };
};
